<template>
  <div>
    <v-autocomplete
      clearable
      outlined
      dense
      item-value="id"
      hide-details
      prepend-inner-icon="mdi-calendar-clock-outline"
      :class="{
        'mt-4 mb-5': !showCustomDueDate,
        'mt-4': showCustomDueDate,
      }"
      :label="$t('common.date_options.due_date')"
      :items="dueDateOptions"
      :value="selectedFilters.dueDateOption"
      @change="handleDateChange($event)"
    />
    <v-menu v-if="showCustomDueDate" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="dateRangeText"
          v-on="on"
          dense
          readonly
          hide-details
          outlined
          event-color="primary"
          prepend-inner-icon="mdi-calendar-outline"
          class="font-size-14 mt-4"
          :label="$t('common.date_options.date_range')"
        />
      </template>

      <v-date-picker
        style="width: 100%;"
        v-model="customDateValues"
        no-title
        range
        reactive
        :value="dateValues"
        @change="onDateRangeChange($event)"
      />
    </v-menu>
  </div>
</template>

<script>
import * as moment from 'moment'
import _ from 'lodash'
import { utils } from 'frontend-js-shared'

import filtersConstants from './Filters/constants'
import { getDateRangeText } from './dateRangeText'

const { dates } = utils
const DATE_FILTER_OPTIONS = filtersConstants.DATE_FILTER_OPTIONS
const DUE_DATE_OPTIONS = [
  {
    id: DATE_FILTER_OPTIONS.all,
    textKey: 'common.date_periods.all',
  },
  ...filtersConstants.DUE_DATE_OPTIONS,
]

export default {
  name: 'DueDateSelector',

  props: {
    selectedFilters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      today: moment().format('YYYY-MM-DD'),
      dueDateOptions: DUE_DATE_OPTIONS.map(option => ({
        id: option.id,
        text: this.$t(option.textKey ?? option.text),
      })),
      customDateValues: [],
    }
  },

  computed: {
    showCustomDueDate() {
      return (
        this.selectedFilters?.dueDateOption === DATE_FILTER_OPTIONS.custom ??
        false
      )
    },

    dateRangeText() {
      return getDateRangeText(Object.values(this.selectedFilters?.dueDate ?? {}))
    },

    dateValues() {
      return _.isEmpty(this.selectedFilters?.dueDate)
        ? []
        : Object.values(this.selectedFilters?.dueDate)
    },
  },

  methods: {
    isDateAllowed(date) {
      return date <= this.today
    },

    handleDateChange(dateRange) {
      switch (dateRange) {
        case DATE_FILTER_OPTIONS.all:
          this.formatDateForFilter(DATE_FILTER_OPTIONS.all, [], 'dueDate')
          break
        case DATE_FILTER_OPTIONS.thisWeek:
          this.formatDateForFilter(
            DATE_FILTER_OPTIONS.thisWeek,
            Object.values(
              dates.getPredefinedDateRange(DATE_FILTER_OPTIONS.thisWeek)
            ),
            'dueDate'
          )
          break
        case DATE_FILTER_OPTIONS.nextWeek: {
          this.formatDateForFilter(
            DATE_FILTER_OPTIONS.nextWeek,
            Object.values(
              dates.getPredefinedDateRange(DATE_FILTER_OPTIONS.nextWeek)
            ),
            'dueDate'
          )
          break
        }
        case DATE_FILTER_OPTIONS.custom:
          this.formatDateForFilter(
            DATE_FILTER_OPTIONS.custom,
            [],
            'dueDateOption'
          )
          break

        default:
          this.formatDateForFilter('', [], 'dueDateOption')
      }
    },

    onDateRangeChange(range = []) {
      const [startDate, endDate] = range
      const startDateTime = moment(startDate).format()
      const endDateTime = moment(endDate)
        .endOf('day')
        .format()

      if (startDateTime > endDateTime)
        this.$emit(
          'change',
          { from: endDateTime, to: startDateTime },
          'dueDate'
        )
      else
        this.$emit(
          'change',
          { from: startDateTime, to: endDateTime },
          'dueDate'
        )
    },

    formatDateForFilter(option, value, key) {
      if (_.isEmpty(value)) {
        this.$emit('change', [], 'dueDate')
        this.$emit('change', option, 'dueDateOption')
        return
      }
      this.$emit(
        'change',
        {
          from: moment(value[0]).format(),
          to: moment(value[1])
            .endOf('day')
            .format(),
        },
        key
      )
      this.$emit('change', option, 'dueDateOption')
    },
  },
}
</script>
